import React from "react";
import { useFormContext } from "react-hook-form";
import { ChevronDown, Info, LifeBuoy } from "react-feather";
import { Link } from "react-router-dom";
import SalaryBlock from "./Components/SalaryBlock";
import BankBlock from "./Components/BankBlock";

const salaryTypes = [
  { id: "Basic", text: "Basic" },
  { id: "Hourly", text: "Hourly" },
  { id: "Daily", text: "Daily" },
];

const option_2 = [
  { id: 1, text: "Yes" },
  { id: 2, text: "No" },
];

const SalaryDetails = () => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  return (
    <>
      <div className="accordion-card-one accordion" id="accordionSalary">
        <div className="accordion-item">
          <div className="accordion-header" id="headingTwo">
            <div
              className="accordion-button"
              data-bs-toggle="collapse"
              data-bs-target="#salary"
              aria-controls="salary"
            >
              <div className="text-editor add-list">
                <div className="addproduct-icon list icon">
                  <h5>
                    <Info className="add-info" />
                    <span>Salary Details</span>
                  </h5>
                  <Link to="#">
                    <ChevronDown className="chevron-down-add" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            id="salary"
            className="accordion-collapse collapse show"
            aria-labelledby="salary"
            data-bs-parent="#accordionSalary"
          >
            <div className="accordion-body">
              <div className="row">
                <SalaryBlock />
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="accordion-card-one accordion" id="accordionBank">
        <div className="accordion-item">
          <div className="accordion-header" id="headingTwo">
            <div
              className="accordion-button"
              data-bs-toggle="collapse"
              data-bs-target="#bank"
              aria-controls="bank"
            >
              <div className="text-editor add-list">
                <div className="addproduct-icon list icon">
                  <h5>
                    <LifeBuoy className="add-info" />
                    <span>Bank Details</span>
                  </h5>
                  <Link to="#">
                    <ChevronDown className="chevron-down-add" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            id="bank"
            className="accordion-collapse collapse show"
            aria-labelledby="bank"
            data-bs-parent="#accordionBank"
          >
            <div className="accordion-body">
              <div className="row">
                <BankBlock />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalaryDetails;
